// tslint:disable max-line-length
import React from 'react';
export var illustrationPaths = {
  destruction: {
    viewBox: '0 0 32 32',
    ariaLabel: 'Destruction',
    path: React.createElement("path", {
      d: "M22.63,0H9.37L0,9.37V22.63L9.37,32H22.63L32,22.63V9.37Zm2,18.72-6.41,5.72h0A5.53,5.53,0,0,1,9,20.31V9.54a.93.93,0,0,1,1.85,0v5.84a.61.61,0,0,0,.61.62.62.62,0,0,0,.62-.62V8.31a.93.93,0,1,1,1.85,0v6.46a.61.61,0,0,0,.61.61.61.61,0,0,0,.62-.61V7.08a.93.93,0,0,1,.92-.93h0a.93.93,0,0,1,.92.93v7.07a.62.62,0,0,0,.62.62.61.61,0,0,0,.61-.62V8.31a.93.93,0,1,1,1.85,0v9.54a.73.73,0,0,0,1.23.43L22.93,17a1.23,1.23,0,0,1,1.74,1.74Z",
      fill: "#d15336"
    })
  },
  information: {
    viewBox: '0 0 32 32',
    ariaLabel: 'Information',
    path: React.createElement("path", {
      d: "M27.26,1H4.74A3.75,3.75,0,0,0,1,4.74V27.26A3.75,3.75,0,0,0,4.74,31H27.26A3.75,3.75,0,0,0,31,27.26V4.74A3.75,3.75,0,0,0,27.26,1ZM16,6a2.5,2.5,0,1,1-2.5,2.5A2.5,2.5,0,0,1,16,6Zm4,20H12V23h2V16H12V13h6V23h2Z",
      fill: "#165cab"
    })
  },
  success: {
    viewBox: '0 0 32 32',
    ariaLabel: 'Success',
    path: React.createElement("path", {
      d: "M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0ZM14,22.81,7.19,16,10,13.19l4,4,8-8L24.81,12Z",
      fill: "#2fa882"
    })
  },
  warning: {
    viewBox: '0 0 32 32',
    ariaLabel: 'Warning',
    path: React.createElement("path", {
      d: "M15.8,28.36a1.8,1.8,0,1,0-1.8-1.8A1.8,1.8,0,0,0,15.8,28.36Zm1.8-5.69h0V10.17a.34.34,0,0,0-.33-.35H14.33a.34.34,0,0,0-.33.35v12.5a.34.34,0,0,0,.33.35h2.94A.34.34,0,0,0,17.6,22.67Zm.19-20.33L30.55,27.87a2,2,0,0,1-.89,2.68,2,2,0,0,1-.9.21H3.24a2,2,0,0,1-1.79-2.89L14.21,2.34a2,2,0,0,1,2.68-.89A1.94,1.94,0,0,1,17.79,2.34Z",
      fill: "#e59539",
      fillRule: "evenodd"
    })
  },
  'app-budget-active': {
    viewBox: '0 0 48 48',
    ariaLabel: 'Budget',
    path: React.createElement(React.Fragment, null, React.createElement("path", {
      fill: "#FFFFFF",
      d: "M47.8,15.8v9l-4.5-4.5L47.8,15.8z M0.2,23.3l4.5,4.5l-4.5,4.5V23.3z M24,1l23,23L24,47L1,24L24,1z"
    }), React.createElement("path", {
      fill: "#9A9CA1",
      d: "M24,11L11,24l13,13l13-13L24,11z M25,30v2h-2v-2c-1.7-0.3-2.9-1.3-3.6-2.9l0-0.1l1.7-0.9l0,0.1\n    c0.7,1.3,1.7,2,3.1,2c1,0,2.3-0.2,2.3-1.4c0-0.9-0.6-1.4-2.5-1.9c-2-0.6-4.1-1.2-4.1-3.6c0-1.8,1.2-3,3.2-3.3v-2h2v2\n    c1.8,0.3,2.8,1.5,3.3,2.4l0,0.1l-1.6,1.1l-0.1-0.1c-0.7-1.1-1.6-1.6-2.8-1.6c-0.7,0-1.9,0.2-1.9,1.2c0,1,0.8,1.4,2.6,1.9\n    c2.1,0.6,4,1.4,4,3.6C28.6,28.5,27.2,29.8,25,30z"
    }), React.createElement("linearGradient", {
      id: "gradient1",
      gradientUnits: "userSpaceOnUse",
      x1: "24",
      y1: "48",
      x2: "24",
      y2: "-9.094947e-13"
    }, React.createElement("stop", {
      offset: "0",
      style: {
        stopColor: '#165CAB'
      }
    }), React.createElement("stop", {
      offset: "0.5",
      style: {
        stopColor: '#044187'
      }
    }), React.createElement("stop", {
      offset: "1",
      style: {
        stopColor: '#165CAB'
      }
    })), React.createElement("path", {
      fill: "url(#gradient1)",
      d: "M47.8,15.8v6.5L44.5,19L47.8,15.8z M24,1v7.5L9.8,22.7L6,19L24,1z M0.2,25.8L3.5,29l-3.2,3.2V25.8z\n     M38.2,25.3L42,29L24,47v-7.5L38.2,25.3z"
    }), React.createElement("linearGradient", {
      id: "gradient2",
      gradientUnits: "userSpaceOnUse",
      x1: "24",
      y1: "48",
      x2: "24",
      y2: "-9.094947e-13"
    }, React.createElement("stop", {
      offset: "0",
      style: {
        stopColor: '#044187'
      }
    }), React.createElement("stop", {
      offset: "0.5058",
      style: {
        stopColor: '#165CAB'
      }
    }), React.createElement("stop", {
      offset: "1",
      style: {
        stopColor: '#044187'
      }
    })), React.createElement("path", {
      fill: "url(#gradient2)",
      d: "M24,1l23.8,23.7v7.5L24,8.5V1z M0.2,15.8L24,39.5V47L0.2,23.2V15.8z"
    }))
  },
  'app-budget-inactive': {
    viewBox: '0 0 48 48',
    ariaLabel: 'Budget',
    path: React.createElement(React.Fragment, null, React.createElement("polygon", {
      fill: "#FFFFFF",
      points: "47.8,15.8 47.8,24.7 43.3,20.2 \t"
    }), React.createElement("polygon", {
      fill: "#FFFFFF",
      points: "0.2,23.3 4.7,27.8 0.2,32.3 \t"
    }), React.createElement("rect", {
      x: "7.8",
      y: "7.7",
      transform: "matrix(0.7068 -0.7074 0.7074 0.7068 -9.9383 24.021)",
      fill: "#FFFFFF",
      width: "32.5",
      height: "32.5"
    }), React.createElement("rect", {
      x: "14.8",
      y: "14.8",
      transform: "matrix(0.7074 -0.7068 0.7068 0.7074 -9.9411 23.9859)",
      fill: "#9A9CA1",
      width: "18.4",
      height: "18.4"
    }), React.createElement("path", {
      fill: "#FFFFFF",
      d: "M25,30v2h-2v-2c-1.7-0.3-2.9-1.3-3.6-2.9l0-0.1l1.7-0.9l0,0.1c0.7,1.3,1.7,2,3.1,2c1,0,2.3-0.2,2.3-1.4\n    c0-0.9-0.6-1.4-2.5-1.9c-2-0.6-4.1-1.2-4.1-3.6c0-1.8,1.2-3,3.2-3.3v-2h2v2c1.8,0.3,2.8,1.5,3.3,2.4l0,0.1l-1.6,1.1l-0.1-0.1\n    c-0.7-1.1-1.6-1.6-2.8-1.6c-0.7,0-1.9,0.2-1.9,1.2c0,1,0.8,1.4,2.6,1.9c2.1,0.6,4,1.4,4,3.6C28.6,28.5,27.2,29.8,25,30z"
    }), React.createElement("polygon", {
      fill: "#616465",
      points: "47.8,15.7 47.8,22.2 44.5,19 \t"
    }), React.createElement("polygon", {
      fill: "#616465",
      points: "24,1 24,8.5 9.8,22.7 6,19 \t"
    }), React.createElement("polygon", {
      fill: "#616465",
      points: "0.2,25.8 3.5,29 0.2,32.2 \t"
    }), React.createElement("polygon", {
      fill: "#616465",
      points: "38.2,25.2 42,29 24,47 24,39.5 \t"
    }), React.createElement("polygon", {
      fill: "#75787A",
      points: "24,1 47.8,24.7 47.8,32.2 24,8.5 \t"
    }), React.createElement("polygon", {
      fill: "#75787A",
      points: "0.2,15.8 24,39.5 24,47 0.2,23.2 \t"
    }))
  },
  'app-data-active': {
    viewBox: '0 0 48 48',
    ariaLabel: 'Data',
    path: React.createElement(React.Fragment, null, React.createElement("linearGradient", {
      id: "gradient-app-data-active",
      gradientUnits: "userSpaceOnUse",
      x1: "24",
      y1: "44.9826",
      x2: "24",
      y2: "3.0174"
    }, React.createElement("stop", {
      offset: "0",
      style: {
        stopColor: '#044187'
      }
    }), React.createElement("stop", {
      offset: "1",
      style: {
        stopColor: '#165CAB'
      }
    })), React.createElement("polygon", {
      fill: "url(#gradient-app-data-active)",
      points: "24,3 4.1,13.3 4.1,34.7 24,45 43.9,34.7 40.4,32.9 24,41.4 6.8,32.5 6.8,29 24,37.8 43.9,27.6\n    40.4,25.8 24,34.3 6.8,25.4 6.8,21.8 24,30.7 43.9,20.4 40.4,18.6 24,27.1 6.8,18.3 6.8,14.7 24,23.6 43.9,13.3 \t"
    }))
  },
  'app-data-inactive': {
    viewBox: '0 0 48 48',
    ariaLabel: 'Data',
    path: React.createElement(React.Fragment, null, React.createElement("polygon", {
      fill: "#616465",
      points: "24,3 4.1,13.3 4.1,34.7 24,45 43.9,34.7 40.4,32.9 24,41.4 6.8,32.5 6.8,29 24,37.8 43.9,27.6\n    40.4,25.8 24,34.3 6.8,25.4 6.8,21.8 24,30.7 43.9,20.4 40.4,18.6 24,27.1 6.8,18.3 6.8,14.7 24,23.6 43.9,13.3 \t"
    }))
  },
  'app-network-active': {
    viewBox: '0 0 48 48',
    ariaLabel: 'Network',
    path: React.createElement(React.Fragment, null, React.createElement("linearGradient", {
      id: "gradient-app-network-active",
      gradientUnits: "userSpaceOnUse",
      x1: "24",
      y1: "44.9826",
      x2: "24",
      y2: "3.0174"
    }, React.createElement("stop", {
      offset: "0",
      style: {
        stopColor: '#044187'
      }
    }), React.createElement("stop", {
      offset: "1",
      style: {
        stopColor: '#165CAB'
      }
    })), React.createElement("path", {
      fill: "url(#gradient-app-network-active)",
      d: "M45,24c0,11.6-9.4,21-21,21S3,35.6,3,24S12.4,3,24,3S45,12.4,45,24"
    }), React.createElement("path", {
      fill: "#FFFFFF",
      d: "M31.8,4.5c-0.5-0.2-1-0.4-1.5-0.5v7.8H41c-0.4-0.5-0.8-1-1.2-1.5h-8.1V4.5z"
    }), React.createElement("path", {
      fill: "#FFFFFF",
      d: "M3.9,17.8h7.8V7c-0.5,0.4-1,0.8-1.5,1.2v8.1H4.5C4.3,16.8,4.1,17.2,3.9,17.8"
    }), React.createElement("path", {
      fill: "#FFFFFF",
      d: "M31,21.5c-1.4,0-2.5,1.1-2.5,2.5c0,1.4,1.1,2.5,2.5,2.5c1.1,0,2.1-0.7,2.4-1.7H45c0-0.3,0-0.5,0-0.7\n    c0-0.3,0-0.5,0-0.7H33.4C33.1,22.2,32.1,21.5,31,21.5"
    }), React.createElement("path", {
      fill: "#FFFFFF",
      d: "M37,28.5c-1.1,0-2.1,0.7-2.4,1.7h-4.4V44c0.5-0.2,1-0.4,1.5-0.5V31.7h2.9c0.3,1,1.3,1.7,2.4,1.7\n    c1.4,0,2.5-1.1,2.5-2.5C39.5,29.6,38.4,28.5,37,28.5"
    }), React.createElement("path", {
      fill: "#FFFFFF",
      d: "M24,3c-0.3,0-0.5,0-0.8,0v14.7h11.4c0.3,1,1.3,1.7,2.4,1.7c1.4,0,2.5-1.1,2.5-2.5c0-1.4-1.1-2.5-2.5-2.5\n    c-1.1,0-2.1,0.7-2.4,1.7h-9.9V3.1C24.5,3,24.3,3,24,3"
    }), React.createElement("path", {
      fill: "#FFFFFF",
      d: "M16.2,14.6c-1,0.3-1.8,1.3-1.8,2.4c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5c0-1.1-0.7-2.1-1.8-2.4V4h-0.1\n    c-0.5,0.1-0.9,0.3-1.4,0.5V14.6z"
    }), React.createElement("path", {
      fill: "#FFFFFF",
      d: "M17,32.5c1.4,0,2.5-1.1,2.5-2.5c0-1.4-1.1-2.5-2.5-2.5c-1.1,0-2.1,0.7-2.4,1.7H3.7c0.1,0.5,0.3,1,0.4,1.5\n    h10.5C14.9,31.8,15.9,32.5,17,32.5"
    }), React.createElement("path", {
      fill: "#FFFFFF",
      d: "M24,45c0.3,0,0.5,0,0.8,0V23.3H11.4c-0.3-1-1.3-1.7-2.4-1.7c-1.4,0-2.5,1.1-2.5,2.5c0,1.4,1.1,2.5,2.5,2.5\n    c1.1,0,2.1-0.7,2.4-1.7h11.9v20.2C23.5,45,23.7,45,24,45"
    }), React.createElement("path", {
      fill: "#FFFFFF",
      d: "M17.2,43.9c0.5,0.2,1,0.3,1.5,0.4v-8.1H7c0.4,0.5,0.8,1,1.2,1.5h9.1V43.9z"
    }))
  },
  'app-network-inactive': {
    viewBox: '0 0 48 48',
    ariaLabel: 'Network',
    path: React.createElement(React.Fragment, null, React.createElement("path", {
      fill: "#616465",
      d: "M45,24c0,11.6-9.4,21-21,21S3,35.6,3,24S12.4,3,24,3S45,12.4,45,24"
    }), React.createElement("path", {
      fill: "#FFFFFF",
      d: "M31.8,4.5c-0.5-0.2-1-0.4-1.5-0.5v7.8H41c-0.4-0.5-0.8-1-1.2-1.5h-8.1V4.5z"
    }), React.createElement("path", {
      fill: "#FFFFFF",
      d: "M3.9,17.8h7.8V7c-0.5,0.4-1,0.8-1.5,1.2v8.1H4.5C4.3,16.8,4.1,17.2,3.9,17.8"
    }), React.createElement("path", {
      fill: "#FFFFFF",
      d: "M31,21.5c-1.4,0-2.5,1.1-2.5,2.5c0,1.4,1.1,2.5,2.5,2.5c1.1,0,2.1-0.7,2.4-1.7H45c0-0.3,0-0.5,0-0.7\n    c0-0.3,0-0.5,0-0.7H33.4C33.1,22.2,32.1,21.5,31,21.5"
    }), React.createElement("path", {
      fill: "#FFFFFF",
      d: "M37,28.5c-1.1,0-2.1,0.7-2.4,1.7h-4.4V44c0.5-0.2,1-0.4,1.5-0.5V31.7h2.9c0.3,1,1.3,1.7,2.4,1.7\n    c1.4,0,2.5-1.1,2.5-2.5C39.5,29.6,38.4,28.5,37,28.5"
    }), React.createElement("path", {
      fill: "#FFFFFF",
      d: "M24,3c-0.3,0-0.5,0-0.8,0v14.7h11.4c0.3,1,1.3,1.7,2.4,1.7c1.4,0,2.5-1.1,2.5-2.5c0-1.4-1.1-2.5-2.5-2.5\n    c-1.1,0-2.1,0.7-2.4,1.7h-9.9V3.1C24.5,3,24.3,3,24,3"
    }), React.createElement("path", {
      fill: "#FFFFFF",
      d: "M16.2,14.6c-1,0.3-1.8,1.3-1.8,2.4c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5c0-1.1-0.7-2.1-1.8-2.4V4h-0.1\n    c-0.5,0.1-0.9,0.3-1.4,0.5V14.6z"
    }), React.createElement("path", {
      fill: "#FFFFFF",
      d: "M17,32.5c1.4,0,2.5-1.1,2.5-2.5c0-1.4-1.1-2.5-2.5-2.5c-1.1,0-2.1,0.7-2.4,1.7H3.7c0.1,0.5,0.3,1,0.4,1.5\n    h10.5C14.9,31.8,15.9,32.5,17,32.5"
    }), React.createElement("path", {
      fill: "#FFFFFF",
      d: "M24,45c0.3,0,0.5,0,0.8,0V23.3H11.4c-0.3-1-1.3-1.7-2.4-1.7c-1.4,0-2.5,1.1-2.5,2.5c0,1.4,1.1,2.5,2.5,2.5\n    c1.1,0,2.1-0.7,2.4-1.7h11.9v20.2C23.5,45,23.7,45,24,45"
    }), React.createElement("path", {
      fill: "#FFFFFF",
      d: "M17.2,43.9c0.5,0.2,1,0.3,1.5,0.4v-8.1H7c0.4,0.5,0.8,1,1.2,1.5h9.1V43.9z"
    }))
  },
  'app-portal-active': {
    viewBox: '0 0 48 48',
    ariaLabel: 'Portal',
    path: React.createElement(React.Fragment, null, React.createElement("linearGradient", {
      id: "gradient-app-portal-active",
      gradientUnits: "userSpaceOnUse",
      x1: "24",
      y1: "46.5",
      x2: "24",
      y2: "1.5"
    }, React.createElement("stop", {
      offset: "0",
      style: {
        stopColor: '#044187'
      }
    }), React.createElement("stop", {
      offset: "1",
      style: {
        stopColor: '#165CAB'
      }
    })), React.createElement("path", {
      fill: "url(#gradient-app-portal-active)",
      d: "M24.8,1.5v1H31v5l-6.2,0l0,2c8.9,0.4,16.1,7.7,16.2,16.7l0,0.3h2v4H5v-4h2c0-9.1,7.2-16.6,16.3-17l0-8H24.8z\n\t\t M43,42.5v4H5v-4H43z"
    }), React.createElement("path", {
      fill: "#FFFFFF",
      d: "M24,13.5c7.2,0,13,5.8,13,13H11C11,19.3,16.8,13.5,24,13.5z"
    }), React.createElement("path", {
      fill: "#9A9CA1",
      d: "M23.8,15.5c5.4,0,9.9,3.9,10.8,9H13C13.9,19.4,18.4,15.5,23.8,15.5z"
    }), React.createElement("path", {
      fill: "#9A9CA1",
      d: "M41,32.5v10h-4v-10H41z M31,32.5v10h-4v-10H31z M21,32.5v10h-4v-10H21z M11,32.5v10H7v-10H11z"
    }))
  },
  'app-portal-inactive': {
    viewBox: '0 0 48 48',
    ariaLabel: 'Portal',
    path: React.createElement(React.Fragment, null, React.createElement("path", {
      fill: "#616465",
      d: "M24.8,1.5v1H31v5l-6.2,0l0,2c8.9,0.4,16.1,7.7,16.2,16.7l0,0.3h2v4H5v-4h2c0-9.1,7.2-16.6,16.3-17l0-8H24.8z"
    }), React.createElement("rect", {
      x: "5",
      y: "42.5",
      fill: "#616465",
      width: "38",
      height: "4"
    }), React.createElement("path", {
      fill: "#FFFFFF",
      d: "M24,13.5c7.2,0,13,5.8,13,13H11C11,19.3,16.8,13.5,24,13.5z"
    }), React.createElement("path", {
      fill: "#9A9CA1",
      d: "M23.8,15.5c5.4,0,9.9,3.9,10.8,9H13C13.9,19.4,18.4,15.5,23.8,15.5z"
    }), React.createElement("rect", {
      x: "37",
      y: "32.5",
      fill: "#9A9CA1",
      width: "4",
      height: "10"
    }), React.createElement("rect", {
      x: "27",
      y: "32.5",
      fill: "#9A9CA1",
      width: "4",
      height: "10"
    }), React.createElement("rect", {
      x: "17",
      y: "32.5",
      fill: "#9A9CA1",
      width: "4",
      height: "10"
    }), React.createElement("rect", {
      x: "7",
      y: "32.5",
      fill: "#9A9CA1",
      width: "4",
      height: "10"
    }))
  },
  'app-reporting-active': {
    viewBox: '0 0 48 48',
    ariaLabel: 'Reporting',
    path: React.createElement(React.Fragment, null, React.createElement("polygon", {
      fill: "#FFFFFF",
      points: "41,41 9,41 9,3 30,3 41,14 \t"
    }), React.createElement("linearGradient", {
      id: "gradient-app-reporting-active",
      gradientUnits: "userSpaceOnUse",
      x1: "24",
      y1: "44.9826",
      x2: "24",
      y2: "3.0174"
    }, React.createElement("stop", {
      offset: "0",
      style: {
        stopColor: '#044187'
      }
    }), React.createElement("stop", {
      offset: "1",
      style: {
        stopColor: '#165CAB'
      }
    })), React.createElement("polygon", {
      fill: "url(#gradient-app-reporting-active)",
      points: "29,3 29,7 11,7 11,41 37,41 37,15 41,15 41,45 7,45 7,3 \t"
    }), React.createElement("rect", {
      x: "14",
      y: "22",
      fill: "#9A9CA1",
      width: "20",
      height: "1"
    }), React.createElement("rect", {
      x: "29",
      y: "25",
      fill: "#9A9CA1",
      width: "5",
      height: "3"
    }), React.createElement("rect", {
      x: "21.5",
      y: "25",
      fill: "#9A9CA1",
      width: "5",
      height: "3"
    }), React.createElement("rect", {
      x: "14",
      y: "25",
      fill: "#9A9CA1",
      width: "5",
      height: "3"
    }), React.createElement("rect", {
      x: "29",
      y: "30",
      fill: "#9A9CA1",
      width: "5",
      height: "3"
    }), React.createElement("rect", {
      x: "21.5",
      y: "30",
      fill: "#9A9CA1",
      width: "5",
      height: "3"
    }), React.createElement("rect", {
      x: "14",
      y: "30",
      fill: "#9A9CA1",
      width: "5",
      height: "3"
    }), React.createElement("rect", {
      x: "29",
      y: "35",
      fill: "#9A9CA1",
      width: "5",
      height: "3"
    }), React.createElement("rect", {
      x: "21.5",
      y: "35",
      fill: "#9A9CA1",
      width: "5",
      height: "3"
    }), React.createElement("rect", {
      x: "14",
      y: "35",
      fill: "#9A9CA1",
      width: "5",
      height: "3"
    }), React.createElement("linearGradient", {
      id: "gradient-gradient-app-reporting-active-2",
      gradientUnits: "userSpaceOnUse",
      x1: "16.4995",
      y1: "22.0017",
      x2: "16.4995",
      y2: "12.0099"
    }, React.createElement("stop", {
      offset: "0",
      style: {
        stopColor: '#044187'
      }
    }), React.createElement("stop", {
      offset: "1",
      style: {
        stopColor: '#165CAB'
      }
    })), React.createElement("rect", {
      x: "15",
      y: "12",
      fill: "url(#gradient-gradient-app-reporting-active-2)",
      width: "3",
      height: "10"
    }), React.createElement("linearGradient", {
      id: "gradient-gradient-app-reporting-active-3",
      gradientUnits: "userSpaceOnUse",
      x1: "31.4995",
      y1: "22.0017",
      x2: "31.4995",
      y2: "17.0058"
    }, React.createElement("stop", {
      offset: "0",
      style: {
        stopColor: '#044187'
      }
    }), React.createElement("stop", {
      offset: "1",
      style: {
        stopColor: '#165CAB'
      }
    })), React.createElement("rect", {
      x: "30",
      y: "17",
      fill: "url(#gradient-gradient-app-reporting-active-3)",
      width: "3",
      height: "5"
    }), React.createElement("linearGradient", {
      id: "gradient-gradient-app-reporting-active-4",
      gradientUnits: "userSpaceOnUse",
      x1: "26.4995",
      y1: "22.0017",
      x2: "26.4995",
      y2: "13.0091"
    }, React.createElement("stop", {
      offset: "0",
      style: {
        stopColor: '#044187'
      }
    }), React.createElement("stop", {
      offset: "1",
      style: {
        stopColor: '#165CAB'
      }
    })), React.createElement("rect", {
      x: "25",
      y: "13",
      fill: "url(#gradient-gradient-app-reporting-active-4)",
      width: "3",
      height: "9"
    }), React.createElement("linearGradient", {
      id: "gradient-gradient-app-reporting-active-5",
      gradientUnits: "userSpaceOnUse",
      x1: "21.4995",
      y1: "22.0017",
      x2: "21.4995",
      y2: "15.0075"
    }, React.createElement("stop", {
      offset: "0",
      style: {
        stopColor: '#044187'
      }
    }), React.createElement("stop", {
      offset: "1",
      style: {
        stopColor: '#165CAB'
      }
    })), React.createElement("rect", {
      x: "20",
      y: "15",
      fill: "url(#gradient-gradient-app-reporting-active-5)",
      width: "3",
      height: "7"
    }), React.createElement("polygon", {
      fill: "#9A9CA1",
      points: "30,3 41,14 30,14 \t"
    }))
  },
  'app-reporting-inactive': {
    viewBox: '0 0 48 48',
    ariaLabel: 'Reporting',
    path: React.createElement(React.Fragment, null, React.createElement("polygon", {
      fill: "#FFFFFF",
      points: "41,41 9,41 9,3 30,3 41,14 \t"
    }), React.createElement("polygon", {
      fill: "#616465",
      points: "29,3 29,7 11,7 11,41 37,41 37,15 41,15 41,45 7,45 7,3 \t"
    }), React.createElement("rect", {
      x: "14",
      y: "22",
      fill: "#9A9CA1",
      width: "20",
      height: "1"
    }), React.createElement("rect", {
      x: "29",
      y: "25",
      fill: "#9A9CA1",
      width: "5",
      height: "3"
    }), React.createElement("rect", {
      x: "21.5",
      y: "25",
      fill: "#9A9CA1",
      width: "5",
      height: "3"
    }), React.createElement("rect", {
      x: "14",
      y: "25",
      fill: "#9A9CA1",
      width: "5",
      height: "3"
    }), React.createElement("rect", {
      x: "29",
      y: "30",
      fill: "#9A9CA1",
      width: "5",
      height: "3"
    }), React.createElement("rect", {
      x: "21.5",
      y: "30",
      fill: "#9A9CA1",
      width: "5",
      height: "3"
    }), React.createElement("rect", {
      x: "14",
      y: "30",
      fill: "#9A9CA1",
      width: "5",
      height: "3"
    }), React.createElement("rect", {
      x: "29",
      y: "35",
      fill: "#9A9CA1",
      width: "5",
      height: "3"
    }), React.createElement("rect", {
      x: "21.5",
      y: "35",
      fill: "#9A9CA1",
      width: "5",
      height: "3"
    }), React.createElement("rect", {
      x: "14",
      y: "35",
      fill: "#9A9CA1",
      width: "5",
      height: "3"
    }), React.createElement("rect", {
      x: "15",
      y: "12",
      fill: "#616465",
      width: "3",
      height: "10"
    }), React.createElement("rect", {
      x: "30",
      y: "17",
      fill: "#616465",
      width: "3",
      height: "5"
    }), React.createElement("rect", {
      x: "25",
      y: "13",
      fill: "#616465",
      width: "3",
      height: "9"
    }), React.createElement("rect", {
      x: "20",
      y: "15",
      fill: "#616465",
      width: "3",
      height: "7"
    }), React.createElement("polygon", {
      fill: "#9A9CA1",
      points: "30,3 41,14 30,14 \t"
    }))
  },
  'app-stories-active': {
    viewBox: '0 0 48 48',
    ariaLabel: 'Stories',
    path: React.createElement(React.Fragment, null, React.createElement("linearGradient", {
      id: "gradient-app-stories-active-1",
      gradientUnits: "userSpaceOnUse",
      x1: "24",
      y1: "43.9834",
      x2: "24",
      y2: "6.0149"
    }, React.createElement("stop", {
      offset: "0",
      style: {
        stopColor: '#044187'
      }
    }), React.createElement("stop", {
      offset: "1",
      style: {
        stopColor: '#165CAB'
      }
    })), React.createElement("path", {
      fill: "url(#gradient-app-stories-active-1)",
      d: "M21,6L21,6c0.1,0,0.2,0,0.2,0c1.2,0,2.3,0.7,2.8,1.8C24.5,6.8,25.5,6,26.8,6c0.1,0,0.2,0,0.3,0l0,0h20v36\n\t\tH27.8c0,1.1-0.9,2-2,2c-0.1,0-0.2,0-0.2,0l0,0h-3l0,0c-0.1,0-0.2,0-0.3,0c-1.1,0-2-0.9-2-2H1V6H21z"
    }), React.createElement("path", {
      fill: "#FFFFFF",
      d: "M21,10c1.1,0,2,0.9,2,2v0v22H5V10H21z"
    }), React.createElement("rect", {
      x: "25",
      y: "34",
      fill: "#9A9CA1",
      width: "18",
      height: "4"
    }), React.createElement("rect", {
      x: "5",
      y: "34",
      fill: "#9A9CA1",
      width: "18",
      height: "4"
    }), React.createElement("path", {
      fill: "#FFFFFF",
      d: "M43,10v24H25V12l0-0.1c0.1-1,0.9-1.8,1.8-1.8l0.1,0H43z"
    }), React.createElement("linearGradient", {
      id: "gradient-app-stories-active-2",
      gradientUnits: "userSpaceOnUse",
      x1: "34",
      y1: "20.9937",
      x2: "34",
      y2: "13.0091"
    }, React.createElement("stop", {
      offset: "0",
      style: {
        stopColor: '#044187'
      }
    }), React.createElement("stop", {
      offset: "1",
      style: {
        stopColor: '#165CAB'
      }
    })), React.createElement("polygon", {
      fill: "url(#gradient-app-stories-active-2)",
      points: "29,21 32.5,16.5 35.5,17.5 39,13 39,21 \t"
    }), React.createElement("linearGradient", {
      id: "gradient-app-stories-active-3",
      gradientUnits: "userSpaceOnUse",
      x1: "18",
      y1: "21.0025",
      x2: "18",
      y2: "14.0083"
    }, React.createElement("stop", {
      offset: "0",
      style: {
        stopColor: '#044187'
      }
    }), React.createElement("stop", {
      offset: "1",
      style: {
        stopColor: '#165CAB'
      }
    })), React.createElement("rect", {
      x: "16.8",
      y: "14",
      fill: "url(#gradient-app-stories-active-3)",
      width: "2.5",
      height: "7"
    }), React.createElement("linearGradient", {
      id: "gradient-app-stories-active-4",
      gradientUnits: "userSpaceOnUse",
      x1: "14",
      y1: "21.0025",
      x2: "14",
      y2: "18.005"
    }, React.createElement("stop", {
      offset: "0",
      style: {
        stopColor: '#044187'
      }
    }), React.createElement("stop", {
      offset: "1",
      style: {
        stopColor: '#165CAB'
      }
    })), React.createElement("rect", {
      x: "12.8",
      y: "18",
      fill: "url(#gradient-app-stories-active-4)",
      width: "2.5",
      height: "3"
    }), React.createElement("linearGradient", {
      id: "gradient-app-stories-active-5",
      gradientUnits: "userSpaceOnUse",
      x1: "10",
      y1: "21.0025",
      x2: "10",
      y2: "16.0066"
    }, React.createElement("stop", {
      offset: "0",
      style: {
        stopColor: '#044187'
      }
    }), React.createElement("stop", {
      offset: "1",
      style: {
        stopColor: '#165CAB'
      }
    })), React.createElement("rect", {
      x: "8.8",
      y: "16",
      fill: "url(#gradient-app-stories-active-5)",
      width: "2.5",
      height: "5"
    }), React.createElement("rect", {
      x: "28",
      y: "23",
      fill: "#9A9CA1",
      width: "12",
      height: "2"
    }), React.createElement("rect", {
      x: "28",
      y: "28",
      fill: "#9A9CA1",
      width: "12",
      height: "2"
    }), React.createElement("rect", {
      x: "8",
      y: "23",
      fill: "#9A9CA1",
      width: "12",
      height: "2"
    }), React.createElement("rect", {
      x: "8",
      y: "28",
      fill: "#9A9CA1",
      width: "12",
      height: "2"
    }))
  },
  'app-stories-inactive': {
    viewBox: '0 0 48 48',
    ariaLabel: 'Stories',
    path: React.createElement(React.Fragment, null, React.createElement("path", {
      fill: "#616465",
      d: "M21,6L21,6c0.1,0,0.2,0,0.2,0c1.2,0,2.3,0.7,2.8,1.8C24.5,6.8,25.5,6,26.8,6c0.1,0,0.2,0,0.3,0l0,0h20v36\n      H27.8c0,1.1-0.9,2-2,2c-0.1,0-0.2,0-0.2,0l0,0h-3l0,0c-0.1,0-0.2,0-0.3,0c-1.1,0-2-0.9-2-2H1V6H21z"
    }), React.createElement("path", {
      fill: "#FFFFFF",
      d: "M21,10c1.1,0,2,0.9,2,2v0v26H5V10H21z"
    }), React.createElement("path", {
      fill: "#FFFFFF",
      d: "M43,10v28H25V12l0-0.1c0.1-1,0.9-1.8,1.8-1.8l0.1,0H43z"
    }), React.createElement("rect", {
      x: "25",
      y: "34",
      fill: "#9A9CA1",
      width: "18",
      height: "4"
    }), React.createElement("rect", {
      x: "5",
      y: "34",
      fill: "#9A9CA1",
      width: "18",
      height: "4"
    }), React.createElement("polygon", {
      fill: "#616465",
      points: "29,21 32.5,16.5 35.5,17.5 39,13 39,21 \t"
    }), React.createElement("rect", {
      x: "16.8",
      y: "14",
      fill: "#616465",
      width: "2.5",
      height: "7"
    }), React.createElement("rect", {
      x: "12.8",
      y: "18",
      fill: "#616465",
      width: "2.5",
      height: "3"
    }), React.createElement("rect", {
      x: "8.8",
      y: "16",
      fill: "#616465",
      width: "2.5",
      height: "5"
    }), React.createElement("rect", {
      x: "28",
      y: "23",
      fill: "#9A9CA1",
      width: "12",
      height: "2"
    }), React.createElement("rect", {
      x: "28",
      y: "28",
      fill: "#9A9CA1",
      width: "12",
      height: "2"
    }), React.createElement("rect", {
      x: "8",
      y: "23",
      fill: "#9A9CA1",
      width: "12",
      height: "2"
    }), React.createElement("rect", {
      x: "8",
      y: "28",
      fill: "#9A9CA1",
      width: "12",
      height: "2"
    }))
  },
  'app-si-active': {
    viewBox: '0 0 48 48',
    ariaLabel: 'Strategic Initiatives',
    path: React.createElement(React.Fragment, null, React.createElement("ellipse", {
      fill: "#FFFFFF",
      cx: "24",
      cy: "24",
      rx: "21.8",
      ry: "21.8"
    }), React.createElement("linearGradient", {
      id: "gradient-app-si-active",
      gradientUnits: "userSpaceOnUse",
      x1: "9.8786",
      y1: "40.8303",
      x2: "38.1226",
      y2: "7.1704"
    }, React.createElement("stop", {
      offset: "0",
      style: {
        stopColor: '#044187'
      }
    }), React.createElement("stop", {
      offset: "1",
      style: {
        stopColor: '#165CAB'
      }
    })), React.createElement("path", {
      fill: "url(#gradient-app-si-active)",
      d: "M24,41c-2.7,0-5.3-0.7-7.6-1.8l-2.5,4.3c3,1.6,6.5,2.5,10.1,2.5c3.6,0,7.1-0.9,10.1-2.5l-2.5-4.3\n    C29.3,40.3,26.7,41,24,41z M2.1,25c0.3,7.4,4.3,13.8,10.1,17.5l2.5-4.3c-4.4-2.9-7.3-7.7-7.6-13.2H2.1z M40.9,25\n    c-0.3,5.5-3.3,10.3-7.6,13.2l2.5,4.3c5.8-3.7,9.8-10.1,10.1-17.5H40.9z M2.1,23h5c0.3-5.5,3.3-10.3,7.6-13.2l-2.5-4.3\n    C6.3,9.2,2.4,15.6,2.1,23z M33.3,9.8c4.4,2.9,7.3,7.7,7.6,13.2h5c-0.3-7.4-4.3-13.8-10.1-17.5L33.3,9.8z M24,2\n    c-3.6,0-7.1,0.9-10.1,2.5l2.5,4.3C18.7,7.7,21.3,7,24,7s5.3,0.7,7.6,1.8l2.5-4.3C31.1,2.9,27.6,2,24,2z"
    }), React.createElement("ellipse", {
      fill: "#9A9CA1",
      cx: "24",
      cy: "24",
      rx: "15",
      ry: "15"
    }), React.createElement("path", {
      fill: "#FFFFFF",
      d: "M32,33H16v-2h1.4v-6.5h-1.3c0.5-3.7,3.5-6.7,7.4-7v-5H28v3h-3.4v2c3.8,0.3,6.9,3.2,7.4,7h-1.3V31H32V33z"
    }), React.createElement("rect", {
      x: "25.2",
      y: "24.4",
      fill: "#9A9CA1",
      width: "3",
      height: "6.6"
    }), React.createElement("rect", {
      x: "19.8",
      y: "24.4",
      fill: "#9A9CA1",
      width: "3",
      height: "6.6"
    }))
  },
  'app-si-inactive': {
    viewBox: '0 0 48 48',
    ariaLabel: 'Strategic Initiatives',
    path: React.createElement(React.Fragment, null, React.createElement("ellipse", {
      fill: "#FFFFFF",
      cx: "24",
      cy: "24",
      rx: "21.8",
      ry: "21.8"
    }), React.createElement("path", {
      fill: "#616465",
      d: "M24,41c-2.7,0-5.3-0.7-7.6-1.8l-2.5,4.3c3,1.6,6.5,2.5,10.1,2.5c3.6,0,7.1-0.9,10.1-2.5l-2.5-4.3\n    C29.3,40.3,26.7,41,24,41z"
    }), React.createElement("path", {
      fill: "#616465",
      d: "M2.1,25c0.3,7.4,4.3,13.8,10.1,17.5l2.5-4.3c-4.4-2.9-7.3-7.7-7.6-13.2H2.1z"
    }), React.createElement("path", {
      fill: "#616465",
      d: "M40.9,25c-0.3,5.5-3.3,10.3-7.6,13.2l2.5,4.3c5.8-3.7,9.8-10.1,10.1-17.5H40.9z"
    }), React.createElement("path", {
      fill: "#616465",
      d: "M2.1,23h5c0.3-5.5,3.3-10.3,7.6-13.2l-2.5-4.3C6.3,9.2,2.4,15.6,2.1,23z"
    }), React.createElement("path", {
      fill: "#616465",
      d: "M33.3,9.8c4.4,2.9,7.3,7.7,7.6,13.2h5c-0.3-7.4-4.3-13.8-10.1-17.5L33.3,9.8z"
    }), React.createElement("path", {
      fill: "#616465",
      d: "M24,2c-3.6,0-7.1,0.9-10.1,2.5l2.5,4.3C18.7,7.7,21.3,7,24,7s5.3,0.7,7.6,1.8l2.5-4.3C31.1,2.9,27.6,2,24,2z"
    }), React.createElement("ellipse", {
      fill: "#9A9CA1",
      cx: "24",
      cy: "24",
      rx: "15",
      ry: "15"
    }), React.createElement("path", {
      fill: "#FFFFFF",
      d: "M32,33H16v-2h1.4v-6.5h-1.3c0.5-3.7,3.5-6.7,7.4-7v-5H28v3h-3.4v2c3.8,0.3,6.9,3.2,7.4,7h-1.3V31H32V33z"
    }), React.createElement("rect", {
      x: "25.2",
      y: "24.4",
      fill: "#9A9CA1",
      width: "3",
      height: "6.6"
    }), React.createElement("rect", {
      x: "19.8",
      y: "24.4",
      fill: "#9A9CA1",
      width: "3",
      height: "6.6"
    }))
  },
  'opengov-logo': {
    viewBox: '0 0 40 40',
    ariaLabel: 'OpenGov',
    path: React.createElement(React.Fragment, null, React.createElement("path", {
      fill: "#FFFFFF",
      d: "M20,35.2c-8.3,0-15.2-6.7-15.2-15.2S11.5,4.8,20,4.8c8.3,0,15.2,6.7,15.2,15.2S28.3,35.2,20,35.2z M20,0\n  C8.9,0,0,9.1,0,20c0,11.1,8.9,20,20,20s20-8.9,20-20C40,9.1,31.1,0,20,0z M28.7,14.9c-0.2-0.2-0.4-0.4-0.6-0.4H11.9\n  c-0.4,0-0.6,0.2-0.8,0.6c0,0.4,0,0.6,0.4,0.8l7.7,4.8v8.5c0,0.4,0.2,0.6,0.6,0.8H20c0.2,0,0.4-0.2,0.6-0.4l8.1-13.9V14.9z"
    }))
  },
  'product-switcher': {
    viewBox: '0 0 24 24',
    ariaLabel: 'Product Switcher',
    path: React.createElement(React.Fragment, null, React.createElement("rect", {
      x: "0",
      y: "0",
      fill: "#1A5DAB",
      width: "6",
      height: "6"
    }), React.createElement("rect", {
      x: "9",
      y: "0",
      fill: "#1A5DAB",
      width: "6",
      height: "6"
    }), React.createElement("rect", {
      x: "18",
      y: "0",
      fill: "#1A5DAB",
      width: "6",
      height: "6"
    }), React.createElement("rect", {
      x: "0",
      y: "9",
      fill: "#1A5DAB",
      width: "6",
      height: "6"
    }), React.createElement("rect", {
      x: "9",
      y: "9",
      fill: "#1A5DAB",
      width: "6",
      height: "6"
    }), React.createElement("rect", {
      x: "18",
      y: "9",
      fill: "#1A5DAB",
      width: "6",
      height: "6"
    }), React.createElement("rect", {
      y: "18",
      fill: "#1A5DAB",
      width: "6",
      height: "6"
    }), React.createElement("rect", {
      x: "9",
      y: "18",
      fill: "#1A5DAB",
      width: "6",
      height: "6"
    }), React.createElement("rect", {
      x: "18",
      y: "18",
      fill: "#1A5DAB",
      width: "6",
      height: "6"
    }))
  }
};